import { Controller } from "@hotwired/stimulus"

// Création d'un champ depuis une fiche : n'affiche que les options du type choisi.
export default class extends Controller {
  static targets = ["type"]
  static values = { map: Object }

  connect() { this.toggle() }

  toggle() {
    const visible = this.mapValue[this.typeTarget.value] || []
    this.element.querySelectorAll("[data-option]").forEach((element) => {
      element.hidden = !visible.includes(element.dataset.option)
    })
  }
}
